import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createSuccessStory, fetchSuccessStories, getSuccessStoryById, deleteSuccessStory, updateSuccessStory } from "../services/successStories";
import { setFilters } from "./matchFilterSlice";

// fetch all success stories
export const fetchAllSuccessStories = createAsyncThunk(
  "successStories/fetchAll",
  async () => {
    const response = await fetchSuccessStories();
    return response.data;
  }
);


// create a new success story
export const saveSuccessStory = createAsyncThunk(
  "successStories/create",
  async (successStoryData) => {
    const response = await createSuccessStory(successStoryData);
    return response.data;
  }
);

//update an existing success story
export const updateSuccessStorySlice = createAsyncThunk(
  "successStories/update",
  async (successStoryData) => {
    const response = await updateSuccessStory(successStoryData);
    return response.data;
  }
);


// get success story by id
export const fetchSuccessStoryById = createAsyncThunk(
  "successStories/fetchById",
    async (id) => {
    const response = await getSuccessStoryById(id);
    return response.data;
  }
);

// delete success story by id
export const removeSuccessStoryById = createAsyncThunk(
  "successStories/deleteById",
    async (id) => {
    await deleteSuccessStory(id);
    return id;
  }
);



const successStorySlice = createSlice({
  name: "successStories",
  initialState: {
    stories: [],
    loading: false,
    error: null
  },
  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAllSuccessStories.pending, (state) => {
      state.loading = true;
      state.error = null;
    }).addCase(fetchAllSuccessStories.fulfilled, (state, action) => {
      state.loading = false;
      state.stories = action.payload;
    }).addCase(fetchAllSuccessStories.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    }).addCase(saveSuccessStory.pending, (state) => {
      state.loading = true;
      state.error = null;
    }).addCase(saveSuccessStory.fulfilled, (state, action) => {
      state.loading = false;
      state.stories.push(action.payload);
    }).addCase(saveSuccessStory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    }).addCase(fetchSuccessStoryById.pending, (state) => {
      state.loading = true;
      state.error = null;
    }).addCase(fetchSuccessStoryById.fulfilled, (state, action) => {
      state.loading = false;
      const index = state.stories.findIndex(story => story.id === action.payload.id);
      if (index !== -1) {
        state.stories[index] = action.payload;
      } else {
        state.stories.push(action.payload);
      }
    }).addCase(fetchSuccessStoryById.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    }).addCase(removeSuccessStoryById.pending, (state) => {
      state.loading = true;
      state.error = null;
    }).addCase(removeSuccessStoryById.fulfilled, (state, action) => {
      state.loading = false;
      state.stories = state.stories.filter(story => story.id !== action.payload);
    }).addCase(removeSuccessStoryById.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
}
});

export const { successStory } = successStorySlice.actions;
export default successStorySlice.reducer;

